import {isNil} from 'ramda';

import {Money} from '@dms/api/shared';

import {Nullish} from 'shared/web';

export function numberToMoney(value: number | Nullish, currency: Money['currency']): Money | null {
  if (isNil(value)) {
    return null;
  }

  return {amount: value.toString(), currency};
}
